import { Link } from 'react-router-dom';

export default function Footer() {
  const handleWhatsAppClick = () => {
    window.open('https://wa.me/5544999957005', '_blank');
  };

  return (
    <footer className="bg-primary text-white py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
          {/* Company Info */}
          <div className="col-span-1 md:col-span-2">
            <img
              src="https://static.readdy.ai/image/38b84c1503cd17b8f12bcbc9adbcc594/67e380c3df490f4157fd930f5cd9671a.png"
              alt="LicitMax"
              width={548}
              height={526}
              loading="lazy"
              className="h-24 w-auto mb-4"
            />
            <p className="text-white/80 mb-4 leading-relaxed">
              Consultoria especializada em licitações e contratos públicos, unindo experiência interna e expertise jurídica.
            </p>
            <button 
              onClick={handleWhatsAppClick}
              className="px-6 py-3 bg-accent text-primary font-semibold rounded-lg hover:bg-accent/90 hover:scale-105 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              Falar com Especialista
            </button>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Links Rápidos</h4>
            <ul className="space-y-2">
              <li>
                <a href="#services" className="text-white/80 hover:text-accent transition-colors cursor-pointer">
                  Soluções
                </a>
              </li>
              <li>
                <a href="#expertise" className="text-white/80 hover:text-accent transition-colors cursor-pointer">
                  Diferenciais
                </a>
              </li>
              <li>
                <a href="#team" className="text-white/80 hover:text-accent transition-colors cursor-pointer">
                  Quem Somos
                </a>
              </li>
              <li>
                <a href="#contact" className="text-white/80 hover:text-accent transition-colors cursor-pointer">
                  Contato
                </a>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Contato</h4>
            <ul className="space-y-2 text-white/80">
              <li className="flex items-center gap-2">
                <i className="ri-phone-line"></i>
                <span>(44) 99995-7005</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-mail-line"></i>
                <span>contato@licitmax.com.br</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-map-pin-line"></i>
                <span>Campo Mourão, PR</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/20 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-white/70 text-sm flex flex-wrap items-center gap-x-2 gap-y-1 justify-center md:justify-start">
            <span>© 2026 LicitMax. Todos os direitos reservados.</span>
            <Link to="/privacidade" className="underline hover:text-accent transition-colors cursor-pointer">
              Privacidade e Segurança
            </Link>
          </p>
          <div className="flex gap-4">
            <a href="https://www.linkedin.com/company/licitmax/" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn da LicitMax" className="text-white/70 hover:text-accent transition-colors cursor-pointer">
              <i className="ri-linkedin-box-fill text-2xl" aria-hidden="true"></i>
            </a>
            <a href="https://www.instagram.com/licitmax/" target="_blank" rel="noopener noreferrer" aria-label="Instagram da LicitMax" className="text-white/70 hover:text-accent transition-colors cursor-pointer">
              <i className="ri-instagram-fill text-2xl" aria-hidden="true"></i>
            </a>
            <a href="https://www.facebook.com/licitmaxcm" target="_blank" rel="noopener noreferrer" aria-label="Facebook da LicitMax" className="text-white/70 hover:text-accent transition-colors cursor-pointer">
              <i className="ri-facebook-box-fill text-2xl" aria-hidden="true"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}